module.exports = {
  ABOUT_ME: 'about-me',
  ABOUT_ME_PROFESSIONAL: 'about-me-professional',
  HEALTH: 'health',
  FAMILY: 'family',
  HOBBIES: 'hobbies',
  LANGUAGE: 'languages',
  LANGUAGE_PROFESSIONAL: 'languages_professional',
  SOFT_SKILLS: 'soft_skills',
  PROFESSIONAL_SKILLS: 'professional_skills',
  TOOLS: 'professional_tools',
  SERVICES: 'services',
  PROJECTS: 'projects',
  AWARDS_HONOUS: 'honors-awards',
  EDUCATION: 'education',
  CERTIFICATE: 'certificate',
  EXPERIENCE: 'experience',
  MAX_DESC_LENGTH: 500,
  ACCEPT: [
    // Images
    'image/jpeg',
    'image/png',
    'image/jpg',
    'image/webp',

    // Videos
    'video/mp4',
    'video/mpeg',
    'video/quicktime',
    'video/x-msvideo',
    'video/webm',

    // PDFs
    'application/pdf',

    // Microsoft Word and similar
    'application/msword',                      // .doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx

    // Microsoft PowerPoint and similar
    'application/vnd.ms-powerpoint',           // .ppt
    'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx

    // Microsoft Excel and similar
    'application/vnd.ms-excel',                // .xls
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx

    // Text files
    // 'text/plain',                              // .txt
    // 'text/csv',                                // .csv
    // 'application/json',                        // .json
    // 'application/xml',                         // .xml

    // Open Document Formats
    'application/vnd.oasis.opendocument.text',           // .odt (Word)
    'application/vnd.oasis.opendocument.spreadsheet',    // .ods (Excel)
    'application/vnd.oasis.opendocument.presentation',   // .odp (PowerPoint)

    // Additional document types
    'application/x-iwork-pages-sffpages',      // Apple Pages
    'application/x-iwork-keynote-sffkey',      // Apple Keynote
    'application/x-iwork-numbers-sffnumbers',  // Apple Numbers
  ],
  ACCEPT_IMAGE: [
    'image/jpeg',
    'image/png',
    'image/jpg',
    'image/webp',
  ],
  ACCEPT_PDF: [
    'application/pdf'
  ],
  ACCEPT_DOCX: [
    'application/msword',                      // .doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  ],
  FILE_TYPE_NAMES : {
    'application/pdf': 'PDF',
    'application/msword': 'DOC',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
  },
  ERRORS: {
    invalidDate: 'End Date cannot precede Start Date',
    invalidEmail: 'Invalid E-mail ID',
  },
  ANDROID_APP_LINK: 'https://play.google.com/store/apps/details?id=com.neoin',
  degreeOptionsByEduLevel : {
    UG: [
      "Bachelor of Architecture (BArch)",
      "Bachelor of Arts (BA)",
      "Bachelor of Ayurvedic Medicine and Surgery (BAMS)",
      "Bachelor of Business Administration (BBA)",
      "Bachelor of Commerce (BCom)",
      "Bachelor of Computer Applications (BCA)",
      "Bachelor of Dental Surgery (BDS)",
      "Bachelor of Design (BDes)",
      "Bachelor of Education (BEd)",
      "Bachelor of Engineering (BE)",
      "Bachelor of Fine Arts (BFA)",
      "Bachelor of Homeopathic Medicine and Surgery (BHMS)",
      "Bachelor of Laws (LLB)",
      "Bachelor of Medicine, Bachelor of Surgery (MBBS)",
      "Bachelor of Nursing (BN)",
      "Bachelor of Pharmacy (BPharm)",
      "Bachelor of Physical Education (BPEd)",
      "Bachelor of Science (BSc)",
      "Bachelor of Social Work (BSW)",
      "Bachelor of Technology (BTech)",
      "Diploma",
    ],
    PG: [
      "Master of Architecture (MArch)",
      "Master of Arts (MA)",
      "Master of Business Administration (MBA)",
      "Master of Commerce (MCom)",
      "Master of Computer Applications (MCA)",
      "Master of Dental Surgery (MDS)",
      "Master of Design (MDes)",
      "Master of Education (MEd)",
      "Master of Engineering (ME)",
      "Master of Fine Arts (MFA)",
      "Master of Laws (LLM)",
      "Master of Pharmacy (MPharm)",
      "Master of Philosophy (MPhil)",
      "Master of Physical Education (MPEd)",
      "Master of Public Health (MPH)",
      "Master of Science (MSc)",
      "Master of Social Work (MSW)",
      "Master of Surgery (MS)",
      "Master of Technology (MTech)",
      "Postgraduate Diploma",
    ],
    HigherEd: [
      "Doctor of Dental Surgery (DDS)",
      "Doctor of Medicine (MD)",
      "Doctor of Philosophy (PhD)",
      "Doctor of Science (DSc)",
      "Doctor of Surgery (MCh)",
      "Integrated Master's Degree",
    ],
    HSC: [
      "Arts",
      "Commerce",
      "Science",
      "Vocational",
    ],
  },
  fieldOfStudyOptions : [
    "Accounting",
    "Agriculture",
    "Architecture",
    "Artificial Intelligence (AI)",
    "Astronomy",
    "Biochemistry",
    "Biology",
    "Biotechnology",
    "Business Administration",
    "Chemical Engineering",
    "Chemistry",
    "Civil Engineering",
    "Commerce",
    "Computer and Information Sciences",
    "Computer Networks and Cybersecurity",
    "Data Science",
    "Dentistry",
    "Design",
    "Economics",
    "Education",
    "Electrical Engineering",
    "Electronics and Communication Engineering",
    "English Literature",
    "Environmental Science",
    "Fashion Design",
    "Finance",
    "Fine Arts",
    "Geography",
    "Geology",
    "Graphic Design",
    "Health Sciences",
    "History",
    "Hospitality Management",
    "Human Resource Management",
    "International Relations",
    "Journalism",
    "Law",
    "Linguistic Studies",
    "Management",
    "Marketing",
    "Mass Communication",
    "Mathematics",
    "Mechanical Engineering",
    "Medical Laboratory Technology",
    "Medicine",
    "Microbiology",
    "Music",
    "Nursing",
    "Nutrition and Dietetics",
    "Pharmacy",
    "Philosophy",
    "Physical Education",
    "Physics",
    "Physiotherapy",
    "Political Science",
    "Psychology",
    "Public Administration",
    "Public Health",
    "Social Work",
    "Sociology",
    "Statistics",
    "Tourism and Travel Management",
    "Veterinary Science",
    "Zoology",
  ]
}